import React, { useEffect, useState } from "react";
import {
  Typography,
  CircularProgress,
  TextField,
  MenuItem,
  Grid,
  Box,
  Stack,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import BottomNav from "./BottomNav";
import CarCard from "./CarCard";
import Logo from "./Logo";
import EmptyState from "./EmptyState";
import Marcas from "./marcas";
import { PageShell, PageHeader, PageContent } from "./Page";

const Home = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");

  useEffect(() => {
    setLoading(true);
    const carsCollectionRef = collection(db, "cars");
    const q = query(carsCollectionRef, orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const carsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        vendido: doc.data().vendido || false,
      }));
      setCars(carsData);
      setLoading(false);
    }, (error) => {
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleMarcaChange = (e) => {
    setSelectedMarca(e.target.value);
  };

  const filteredCars = cars.filter((car) => {
    const searchMatch =
      (car.title && car.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (car.description && car.description.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (car.price && car.price.toString().includes(searchTerm)) ||
      (car.city && car.city.toString().includes(searchTerm)) ||
      (car.modelo && car.modelo.toString().includes(searchTerm)) ||
      (car.marca && car.marca.toString().toLowerCase().includes(searchTerm.toLowerCase()));
    const brandMatch =
      selectedMarca === "" ||
      (car.marca && car.marca.toLowerCase().includes(selectedMarca.toLowerCase()));
    return searchMatch && brandMatch;
  });

  return (
    <PageShell>
      <PageHeader
        back={false}
        leading={<Logo size={36} sx={{ display: { md: "none" } }} />}
        title="Explorar vehículos"
        subtitle="Encontrá tu próximo auto"
      />

      <PageContent>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ mb: 3 }}>
          <TextField
            placeholder="Buscar por título, ciudad, modelo..."
            value={searchTerm}
            onChange={handleSearchChange}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            select
            label="Marca"
            value={selectedMarca}
            onChange={handleMarcaChange}
            sx={{ minWidth: { sm: 220 } }}
          >
            <MenuItem value="">Todas</MenuItem>
            {Marcas.map((marca) => (
              <MenuItem key={marca} value={marca}>
                {marca}
              </MenuItem>
            ))}
          </TextField>
        </Stack>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
            <CircularProgress color="secondary" />
          </Box>
        ) : filteredCars.length > 0 ? (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {filteredCars.length} {filteredCars.length === 1 ? "vehículo" : "vehículos"}
            </Typography>
            <Grid container spacing={2.5}>
              {filteredCars.map((car) => (
                <Grid item key={car.id} xs={12} sm={6} md={4}>
                  <CarCard car={car} />
                </Grid>
              ))}
            </Grid>
          </>
        ) : (
          <EmptyState
            icon={<DirectionsCarOutlinedIcon />}
            title="No se encontraron vehículos"
            text="Probá con otra búsqueda o cambiá la marca seleccionada."
          />
        )}
      </PageContent>

      <BottomNav />
    </PageShell>
  );
};

export default Home;
